import { Button } from "react-bootstrap";
import { useChat } from "@/contexts/ChatContext";
export default function ChatNotificationControl() {
  const { notifications } = useChat();
  if (!notifications) return null;
  const { status, error, enable, disable } = notifications;
  return (
    <div className="chat-notification-control">
      {status === "unsupported" ? (
        <p>
          Notifications navigateur indisponibles ici. Sur iPhone ou iPad,
          ajoutez le CRM à l’écran d’accueil.
        </p>
      ) : status === "denied" ? (
        <p>
          Notifications bloquées. Autorisez-les dans les réglages de ce site
          dans votre navigateur.
        </p>
      ) : (
        <>
          <Button
            variant="link"
            size="sm"
            disabled={status === "busy"}
            onClick={status === "on" ? disable : enable}
          >
            {status === "busy"
              ? "Mise à jour…"
              : status === "on"
                ? "Désactiver les notifications navigateur"
                : "Activer les notifications navigateur"}
          </Button>
          <p>
            {status === "on"
              ? "Actives sur ce navigateur, même CRM fermé."
              : "Recevez vos messages même quand le CRM est fermé."}
          </p>
        </>
      )}
      {error && (
        <p role="alert" className="text-danger">
          {error}
        </p>
      )}
    </div>
  );
}
